import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';

import { useCadRendererSyncStatus } from './cad-renderer-sync-context.js';

export function SyncStatusIndicator() {
	const sync = useCadRendererSyncStatus();

	if (!sync.hasPeers) {
		return null;
	}

	const title =
		!sync.isEnabled ? `Window sync disabled${formatPeerCount(sync.peerCount)}`
		: sync.isLinked ? `Window sync linked${formatPeerCount(sync.enabledPeerCount)}`
		: `Window sync enabled${formatPeerCount(sync.peerCount)}`;
	const Icon = sync.isEnabled ? LinkIcon : LinkOffIcon;

	return (
		<Tooltip placement='top' title={<p className='text-sm'>{title}</p>} disableInteractive>
			<span>
				<IconButton
					size='small'
					aria-label={title}
					className={clsx(
						'p-0.5',
						sync.isLinked && 'text-green-10',
						sync.isEnabled && !sync.isLinked && 'text-blue-10',
						!sync.isEnabled && 'text-gray-a9',
					)}
					onClick={() => sync.setEnabled(!sync.isEnabled)}
				>
					<Icon fontSize='small' />
				</IconButton>
			</span>
		</Tooltip>
	);
}

function formatPeerCount(count: number): string {
	if (count === 0) {
		return '';
	}

	return count === 1 ? ' (1 peer)' : ` (${count} peers)`;
}
